import Work1 from '../../assets/work1.jpg'
import Work2 from '../../assets/work2.jpg'
import Work3 from '../../assets/work3.jpg'
import Work4 from '../../assets/work4.jpg'
import Work5 from '../../assets/work5.jpg'

export const projectsData = [
    {
        id:1,
        image: Work1,
        title: 'Light Crescent',
        category: 'web',
        link : 'https://lightcrescent.com/index.html'
    },
    {
        id:2,
        image: Work2,
        title: 'Best one way cabs',
        category: 'web',
        link : 'https://www.bestonewaycabs.com/'
    },
    {
        id:3,
        image: Work3,
        title: 'brand design',
        category: 'web',
        link : 'https://www.abiinfrastructure.com/'
    },
    {
        id:4,
        image: Work4,
        title: 'pixcep infotech',
        category: 'web',
        link : 'https://picxelinfotech.com/index.html'
    },
    {
        id:5,
        image: Work5,
        title: 'Intercity riders',
        category: 'web',
        link : 'https://intercityriders.com/'
    },
];


export const projectNav = [
    {
        name : 'all',
    },
    {
        name : 'web',
    },
    // {
    //     name : 'app',
    // },
    {
        name : 'design',
    },
    
]